import {BaseComponent} from '../base.component';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Notification} from '../../model/notification';
import {ApplicationConfig} from '../../../../config/application.config';
import {IChappsListItem} from '@npm.chapps.com/chapps.common.angular.library';
import {IssueNotificationStatus} from '../../enums/enums';

@Component({
  selector: 'app-notification-list-item',
  templateUrl: './notification-list-item.component.html',
  styleUrls: ['./notification-list-item.component.scss'],
})
export class NotificationListItemComponent extends BaseComponent implements IChappsListItem {

  @Input() model: Notification;
  @Output() clicked: EventEmitter<Notification> = new EventEmitter<Notification>();

  constructor(public applicationConfig: ApplicationConfig) {
    super();
  }

  public onClick() {
    this.clicked.emit(this.model);
  }

  public isHandled(): boolean {
    return this.model.status === IssueNotificationStatus.HANDLED;
  }
}
